import cx from 'clsx';

import { useCurrentUserMyPage } from '~/domains/auth/queries';

import { MembershipDiscountTooltip } from './MembershipDiscountTooltip';

/**
 * 멤버십 가입자를 위한 넛지
 * */
export function MembershipDiscountInfo() {
  const data = useCurrentUserMyPage();

  if (!data?.discountUsages?.length) {
    return null;
  }

  return (
    <div
      className={cx([
        'flex flex-col items-center rounded-[8px] border px-16 border-bonuspack-background',
        '[&>div]:py-8 [&>div:not(:first-child)]:border-solid [&>div:not(:first-child)]:border-t [&>div:not(:first-child)]:border-t-gray-100',
      ])}
    >
      {data?.discountUsages.map((usage) => {
        return (
          <div className="flex w-full justify-between">
            <div className="flex items-center gap-2">
              <p className="text-bonuspackGreen-text typo-caption100-semibold">
                {usage?.title}
              </p>
              {usage.tooltip && (
                <MembershipDiscountTooltip
                  description={usage.tooltip}
                  className="[&>div:after]:left-[91px] [&>div]:!left-[-90px]"
                />
              )}
            </div>
            <div className="flex items-center gap-2">
              <p className="text-normal typo-caption100-semibold">
                {usage?.remainDiscountAmount?.toLocaleString()}원 남음
              </p>
              <p className="text-description typo-caption100-regular">
                / {usage?.maximumDiscountAmount?.toLocaleString()}원
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
